import { getMenuSelectedKeys } from './workspaceMenuUtils.js';

export { getMenuSelectedKeys };

export function getSelectionMenuSelectedKeys(pathname, menuEntries) {
    if (!pathname || !Array.isArray(menuEntries) || menuEntries.length === 0) {
        return [];
    }
    const infoEntry = menuEntries[0];
    if (pathname === '/selection/projects/new' && infoEntry?.key) {
        return [infoEntry.key];
    }
    return getMenuSelectedKeys(pathname, menuEntries);
}
